module.exports = __webpack_public_path__ + "img/construction-excavator-icon.7b8020c5.svg";